import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import { ROUTE_PATHS } from "@/lib/index";

// Initialize the QueryClient for data fetching and caching
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

/**
 * App Component
 * Sets up the global providers and routing architecture for Car Dent Paintless Repair.
 * Uses HashRouter for broad compatibility and Layout for consistent navigation.
 */
const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        {/* UI Feedback Components */}
        <Toaster />
        <Sonner position="top-right" closeButton />

        <HashRouter>
          <Layout>
            <Routes>
              {/* Main Landing Page */}
              <Route path={ROUTE_PATHS.HOME} element={<Home />} />

              {/* Professional Services Details */}
              <Route path={ROUTE_PATHS.SERVICES} element={<Services />} />

              {/* Company & Team Information */}
              <Route path={ROUTE_PATHS.ABOUT} element={<About />} />

              {/* Showcase of Before/After Work */}
              <Route path={ROUTE_PATHS.GALLERY} element={<Gallery />} />

              {/* Appointment Booking & Contact */}
              <Route path={ROUTE_PATHS.CONTACT} element={<Contact />} />

              {/* Fallback Route for non-existent paths */}
              <Route
                path="*"
                element={
                  <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
                    <h1 className="text-4xl font-bold mb-4 text-primary">404</h1>
                    <p className="text-xl text-muted-foreground mb-8">
                      Hoppla! Die gewünschte Seite wurde nicht gefunden.
                    </p>
                    <a
                      href="#/"
                      className="px-6 py-3 bg-primary text-primary-foreground rounded-md hover:opacity-90 transition-opacity"
                    >
                      Zurück zur Startseite
                    </a>
                  </div>
                }
              />
            </Routes>
          </Layout>
        </HashRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
